export default __webpack_public_path__ + "static/caduceus-8c626c2694a98683b2556820773f2d89.png";